import React from "react";
import { Box, Button } from "@mui/material";
import { BedroomChild, HowToReg, ArrowBack } from "@mui/icons-material";
import { Stack } from "@mui/system";
import { TrackerRecordData } from "../../types/Patient";
import { UserData } from "../../types/User";

type ComponentProps = {
  handleBack: () => void;
  handleRegister: () => void;
  detailData: UserData;
  registeredIds: TrackerRecordData[];
};

const PatientButtons: React.FC<ComponentProps> = ({
  handleBack,
  handleRegister,
  detailData,
  registeredIds,
}) => {
  return (
    <Box sx={{ padding: "5px" }}>
      <Stack spacing={2}>
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<ArrowBack />}
          fullWidth
          onClick={handleBack}
        >
          Back
        </Button>
        {!registeredIds.some((r) => r.recordId === detailData.id) && (
          <Button
            variant="contained"
            color="success"
            onClick={handleRegister}
            startIcon={<HowToReg />}
            fullWidth
          >
            Register
          </Button>
        )}

        <Button
          variant="contained"
          color="success"
          startIcon={<BedroomChild />}
          fullWidth
        >
          Admit
        </Button>
      </Stack>
    </Box>
  );
};

export default PatientButtons;
